/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import AbstractModule from "../abstract_module";
import {mat4, vec2, vec3} from "gl-matrix";
import IModel from "../../structural_elements/model_interface";
import {RenderDocument, Debug} from "js_renderer";
import IActivityModule from "./scene_activity_interface";
import Scene from "../../scene";
import Settings from "../settings";

/***
 * this is temporary replacement for select and change/open dialog/etc. approach which is still not yet needed
 */
export default
class ActivityModule extends AbstractModule implements IActivityModule {

    protected static _typeName: string = "activity";
    // protected static _eType: ESceneModules = ESceneModules.ACTIVITY;

    private _activeObject: IModel;
    private _runtimeSettings: any;

    constructor(aRenderDocument: RenderDocument) {
        super(aRenderDocument);
        this._type = ActivityModule._typeName;

        this._activeObject = null;

        this._runtimeSettings = {
            manipulatorTransformation: mat4.create()
        }
    }

    public static getClassType(): string {
        return ActivityModule._typeName;
    }

    public viewChanged() {
    }

    public viewResized(aContentSize: vec2) {
    }

    public setActiveObject(aObject: IModel) {
        this._activeObject = aObject;
    }

    /**
     * @return {cadwork.webgl.SceneAPI.Model}
     */
    public getActiveObject() {
        if (this._activeObject === null) {
            // set default model (first one) as an active object if there is no active object set yet
            let models = this.renderDocument.getModelsList();
            for (let key in models) {
                this._activeObject = models[key].getSceneAPIModel();
                if (this._activeObject && this._activeObject.isManipulationAllowed()) {
                    break;
                }
            }
        }

        return this._activeObject;
    }

    public setCurrentManipulatorTransformation(aTransformation: mat4) {
        this._runtimeSettings.manipulatorTransformation = mat4.clone(aTransformation);

        //this._notifyObservers("onManipulatorChanged");

        // Schedule Redraw
        this.sceneAPI.viewModeModule.scheduleRedraw();
    }

    /***
     * Only for private  usage in the engine as it returns transformation without zero point accommodated.
     *
     * @returns {mat4}
     * @private
     */
    public getCurrentManipulatorTransformation(): mat4 {
        return this._runtimeSettings.manipulatorTransformation;
    }

    public transformByCurrentManipulatorTransformation(aPoint: vec3): vec3 {
        let point = vec3.create();

        // transform the point by the manipulator transformation
        vec3.transformMat4(point, aPoint, this._runtimeSettings.manipulatorTransformation);

        return point;
    }
}

Scene.registerSceneAPIModule(ActivityModule);
